<!-- Define our page card. -->
<mat-card class="mat-page-card">

  <!-- Define the header of our page card. -->
  <mat-card-header>

    <!-- Give our page an icon. -->
    <mat-icon mat-card-avatar color="icon-orange">domain</mat-icon>

    <!-- Give our page a main title. -->
    <mat-card-title>
      Professional Employer Organization (PEO) Client Management
    </mat-card-title>

    <!-- Give our page a very short description. -->
    <mat-card-subtitle *ngIf="!peoId">
      Below is a table of the existing PEO Client-Customer Mappings in the system along with their management actions.
    </mat-card-subtitle>

    <!-- Give our page a very short description. -->
    <mat-card-subtitle *ngIf="peoId">
      Below is a table of the existing PEO Client-Customer Mappings for <strong>{{ peoId }}</strong>
      in the system along with their management actions.
    </mat-card-subtitle>
  </mat-card-header>

  <!-- Define the content of our page card. -->
  <mat-card-content>
    <div>

      <div class="table-controls">

        <!-- Table Filter -->
        <mat-form-field>
          <mat-label>Search the table below</mat-label>
          <input matInput [(ngModel)]="filterInput" (keyup)="filterTable($event)" placeholder="Acme, Inc" type="text">

          <button *ngIf="filterInput" mat-icon-button matSuffix matTooltip="Clear table filter."
                  aria-label="Clear PEO Client table filter." (click)="clearFilter()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- Paginator -->
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 75, 100, 250, 500, 1000, 5000, 10000]"
                       aria-label="Select page size of PEO Clients table."></mat-paginator>
      </div>

      <table mat-table matSort [dataSource]="clientDataSource" class="mat-elevation-z8">

        <!-- PEO ID Column -->
        <ng-container matColumnDef="peoId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Peo ID</th>
          <td mat-cell *matCellDef="let c;">
            <span>{{ c.peoId }}</span>
          </td>
        </ng-container>

        <!-- Client ID Column -->
        <ng-container matColumnDef="clientId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Client ID</th>
          <td mat-cell *matCellDef="let c;">
            <span>{{ c.clientId }}</span>
          </td>
        </ng-container>

        <!-- Customer ID Column -->
        <ng-container matColumnDef="customerId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Customer ID</th>
          <td mat-cell *matCellDef="let c">{{ c.customerId }}</td>
        </ng-container>

        <!-- Customer Name Column -->
        <ng-container matColumnDef="customerName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Customer</th>
          <td mat-cell *matCellDef="let c;">
            <span>{{ c.customerName }}</span>
          </td>
        </ng-container>

        <!-- Customer Brand Column -->
        <ng-container matColumnDef="customerBrand">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Brand</th>
          <td mat-cell *matCellDef="let c;">
            <span>{{ c.customerBrandName }}</span>
          </td>
        </ng-container>

        <!-- Last Previewed Column -->
        <ng-container matColumnDef="lastPreviewed">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Previewed</th>
          <td mat-cell *matCellDef="let c;">
            <span *ngIf="c.lastPreviewed">{{ c.lastPreviewed | date: 'short' }}</span>
            <span *ngIf="!c.lastPreviewed">Never</span>
          </td>
        </ng-container>

        <!-- Last Printed Column -->
        <ng-container matColumnDef="lastPrinted">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Printed</th>
          <td mat-cell *matCellDef="let c;">
            <span *ngIf="c.lastPrinted">{{ c.lastPrinted | date: 'short' }}</span>
            <span *ngIf="!c.lastPrinted">Never</span>
          </td>
        </ng-container>

        <!-- Print Settings Column -->
        <ng-container matColumnDef="printSetup">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Print Setup</th>
          <td mat-cell *matCellDef="let c">
          <span *ngIf="!clientToggles[getToggleKey(c)].loading && !clientToggles[getToggleKey(c)].saving"
                [class]="c.printSettingsNotSetUp ? 'text-red' : ''">
            {{ c.printSetup }}
          </span>
          <mat-spinner *ngIf="clientToggles[getToggleKey(c)].loading || clientToggles[getToggleKey(c)].saving"
                       color="warn" diameter="20"></mat-spinner>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="_actions">
          <th mat-header-cell *matHeaderCellDef class="align-end">

            <!-- New PEO Client-Customer Mapping -->
            <button *ngIf="!filterInput" mat-icon-button (click)="modifyClient()" [disabled]="loading"
                    aria-label="Button to create a new PEO Client-Customer Mapping."
                    color="primary"
                    matTooltip="Add PEO Client-Customer Mapping." type="button">
              <mat-icon>add</mat-icon>
            </button>

            <!-- Revert Print Settings to Standard for All Client-Customers -->
            <button mat-icon-button matTooltip="Revert Print Settings to Standard for All Client-Customers."
                    (click)="savePrintSettingsForAllClients(true)"
                    [color]="!clientDataSource.data.length || printSettingsLoading || printSettingsSaving ? 'icon-slate' : 'icon-orange'"
                    [disabled]="!clientDataSource.data.length || printSettingsLoading || printSettingsSaving">
              <mat-icon>print</mat-icon>
            </button>

            <!-- Reconfigure Print Settings to PrismHR for All Client-Customers -->
            <button mat-icon-button matTooltip="Reconfigure Print Settings to PrismHR for All Client-Customers."
                    (click)="savePrintSettingsForAllClients()"
                    [color]="!clientDataSource.data.length || printSettingsLoading || printSettingsSaving ? 'icon-slate' : 'icon-green'"
                    [disabled]="!clientDataSource.data.length || printSettingsLoading || printSettingsSaving">
              <mat-icon>print</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let c" class="align-end">

            <!-- Edit PEO Client-Customer Mapping -->
            <button mat-icon-button (click)="modifyClient(c)" color="primary"
                    aria-label="Button to edit PEO Client-Customer Mapping."
                    matTooltip="Modify PEO Client Customer-Mapping."
                    type="button">
              <mat-icon>edit</mat-icon>
            </button>

            <!-- Revert PEO Client Print Settings to a Standard Configuration -->
            <button mat-icon-button matTooltip="Revert Print Settings to Standard." (click)="savePrintSettings(c, true)"
                    [color]="c.printSettingsSetUpForStandard || clientToggles[getToggleKey(c)].saving ? 'icon-slate' : 'icon-orange'"
                    [disabled]="c.printSettingsSetUpForStandard || clientToggles[getToggleKey(c)].loading || clientToggles[getToggleKey(c)].saving">
              <mat-icon>print</mat-icon>
            </button>

            <!-- Reconfigure PEO Client Print Settings to a PrismHR Configuration -->
            <button mat-icon-button matTooltip="Reconfigure Print Settings to PrismHR." (click)="savePrintSettings(c)"
                    [color]="c.printSettingsSetUpForPrismHr || clientToggles[getToggleKey(c)].saving ? 'icon-slate' : 'icon-green'"
                    [disabled]="c.printSettingsSetUpForPrismHr || clientToggles[getToggleKey(c)].loading || clientToggles[getToggleKey(c)].saving">
              <mat-icon>print</mat-icon>
            </button>

            <!-- View Document Split Status -->
            <button mat-icon-button (click)="viewClientDocumentSplitStatus(c)" [disabled]="loading"
                    aria-label="Button to view the Document Split Status."
                    color="icon-blue"
                    matTooltip="View Document Split Status." type="button">
              <mat-icon>picture_as_pdf</mat-icon>
            </button>

            <!-- Delete PEO Client-Customer Mapping -->
            <button mat-icon-button (click)="deleteClient(c)" color="icon-red"
                    aria-label="Button to delete PEO Client-Customer Mapping."
                    matTooltip="Delete PEO Client Customer-Mapping."
                    type="button">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" *ngIf="!!filterInput && !loading" colspan="9" style="text-align: center;">No PEO
            Client-Customer
            Mappings found matching "{{ filterInput }}".
          </td>
          <td class="mat-cell" *ngIf="loading" colspan="9">
            <span style="display: flex; justify-content: center; align-items: center; width: 100%;">
              <mat-spinner color="warn" diameter="20"></mat-spinner>
              &nbsp;
              Loading
            </span>
          </td>
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
